import React from 'react';
import { InputNumber } from 'antd';
import type { DynamicComponentProps } from '@/types/commontypes';
import styles from '../../../styles/global.module.css';

interface NumberInputProps extends DynamicComponentProps<number> {
  min?: number;
  max?: number;
  step?: number;
}

/**
 * NumberInput - Number input field for shape properties
 */
const NumberInput: React.FC<NumberInputProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  min = 1,
  max = 100,
  step = 1,
  isFromMiniToolbar,
}) => {
  const handleChange = (val: number | null) => {
    if (val !== null) {
      onChange(val);
    }
  };

  const inputElement = (
    <InputNumber
      value={value}
      onChange={handleChange}
      disabled={disabled}
      min={min}
      max={max}
      step={step}
      size="small"
      style={{ width: 70 }}
    />
  );

  if (isFromMiniToolbar) {
    return <div className="flex items-center gap-2">{inputElement}</div>;
  }

  return (
    <div className={styles.property_row}>
      {label && <label className={styles.property_label}>{label}</label>}
      <div className={styles.property_value}>{inputElement}</div>
    </div>
  );
};

export default NumberInput;
